import { AlertTriangle, Loader2, Trash2 } from "lucide-react";
import { useState } from "react";
import { Button, Input, Modal, ModalBody, ModalFooter } from "../ui";

type Props = {
  open: boolean;
  onClose: () => void;
  clubName: string;
  isPending: boolean;
  onConfirm: () => void;
};

export function DeleteClubModal({ open, onClose, clubName, isPending, onConfirm }: Props) {
  const [confirmText, setConfirmText] = useState("");
  const canDelete = confirmText === clubName;

  return (
    <Modal open={open} onClose={onClose} className="!max-w-sm">
      <div className="px-6 pt-6 pb-1 flex items-center gap-3">
        <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-error-500/10 border border-error-500/20">
          <AlertTriangle className="size-5 text-error-400" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-white">Delete Club</h2>
          <p className="text-sm text-surface-400">This action is irreversible</p>
        </div>
      </div>
      <ModalBody className="space-y-4">
        <p className="text-sm text-surface-300">
          Type <span className="font-semibold text-white">{clubName}</span> to confirm deletion.
        </p>
        <Input
          placeholder="Type club name to confirm"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          autoFocus
        />
      </ModalBody>
      <ModalFooter>
        <Button variant="ghost" onClick={onClose} disabled={isPending}>
          Cancel
        </Button>
        <Button
          variant="primary"
          className="!bg-error-500 hover:!bg-error-600"
          disabled={!canDelete || isPending}
          leftIcon={
            isPending ? <Loader2 className="size-4 animate-spin" /> : <Trash2 className="size-4" />
          }
          onClick={onConfirm}
        >
          {isPending ? "Deleting..." : "Delete Club"}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
